"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateScheduleAvailabilityDateDto = instanceOfUpdateScheduleAvailabilityDateDto;
exports.UpdateScheduleAvailabilityDateDtoFromJSON = UpdateScheduleAvailabilityDateDtoFromJSON;
exports.UpdateScheduleAvailabilityDateDtoFromJSONTyped = UpdateScheduleAvailabilityDateDtoFromJSONTyped;
exports.UpdateScheduleAvailabilityDateDtoToJSON = UpdateScheduleAvailabilityDateDtoToJSON;
exports.UpdateScheduleAvailabilityDateDtoToJSONTyped = UpdateScheduleAvailabilityDateDtoToJSONTyped;
const ShiftTime_1 = require("./ShiftTime");
/**
 * Check if a given object implements the UpdateScheduleAvailabilityDateDto interface.
 */
function instanceOfUpdateScheduleAvailabilityDateDto(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('available' in value) || value['available'] === undefined)
        return false;
    return true;
}
function UpdateScheduleAvailabilityDateDtoFromJSON(json) {
    return UpdateScheduleAvailabilityDateDtoFromJSONTyped(json, false);
}
function UpdateScheduleAvailabilityDateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'],
        'available': json['available'],
        'shiftTime': json['shiftTime'] == null ? undefined : (0, ShiftTime_1.ShiftTimeFromJSON)(json['shiftTime']),
        'customStartTime': json['customStartTime'] == null ? undefined : json['customStartTime'],
        'customEndTime': json['customEndTime'] == null ? undefined : json['customEndTime'],
    };
}
function UpdateScheduleAvailabilityDateDtoToJSON(json) {
    return UpdateScheduleAvailabilityDateDtoToJSONTyped(json, false);
}
function UpdateScheduleAvailabilityDateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'available': value['available'],
        'shiftTime': (0, ShiftTime_1.ShiftTimeToJSON)(value['shiftTime']),
        'customStartTime': value['customStartTime'],
        'customEndTime': value['customEndTime'],
    };
}
//# sourceMappingURL=UpdateScheduleAvailabilityDateDto.js.map